import { useEffect, useRef, useState } from "react";
import { Mail, Phone, AtSign, Globe, ExternalLink } from "lucide-react";

/**
 * contacts: [{ kind, value, icon }]
 * Renders each icon as a button. Clicking opens a small modal with the value.
 * Clicking anywhere else or pressing Esc closes it.
 */
export default function ContentContacts({ contacts = [] }) {
  const [openIdx, setOpenIdx] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    function onDocMouseDown(e) {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(e.target)) setOpenIdx(null);
    }
    function onEsc(e) {
      if (e.key === "Escape") setOpenIdx(null);
    }
    document.addEventListener("mousedown", onDocMouseDown);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocMouseDown);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  return (
    <div className="segment-contacts" ref={containerRef}>
      {contacts.map((c, idx) => {
        const isOpen = openIdx === idx;
        return (
          <div className="icon" key={`${c.kind}-${idx}`}>
            <button
              type="button"
              className={`svg contact-trigger ${c.kind}-link`}
              aria-haspopup="dialog"
              aria-expanded={isOpen}
              aria-controls={`contact-popover-${idx}`}
              onClick={() => setOpenIdx(isOpen ? null : idx)}
              title={c.kind}
            >
              {c.icon === "mail" && <Mail size="20" alt={c.kind} />}
              {c.icon === "phone" && <Phone size="20" alt={c.kind} />}
              {c.icon === "email" && <AtSign size="20" alt={c.kind} />}
              {c.icon === "web" && <Globe size="20" alt={c.kind} />}
              {/* <img
                src={c.icon}
                width="24"
                height="24"
                className="link-icon"
                alt={c.kind}
              /> */}
            </button>

            {isOpen && (
              <div
                id={`contact-popover-${idx}`}
                role="dialog"
                aria-label={`${c.kind} info`}
                className="contact-popover"
              >
                <div className="contact-popover-content">{renderValue(c)}</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

function renderValue(c) {
  const v = (c.value || "").trim();

  // URL-like values (web/reservation/status/map)
  if (
    c.kind === "web" ||
    c.kind === "reservation" ||
    c.kind === "status" ||
    c.kind === "map" ||
    /^https?:\/\//i.test(v)
  ) {
    return v ? (
      <a href={v} target="_blank" rel="noopener noreferrer">
        {v}
      </a>
    ) : (
      <span>No {c.kind} provided</span>
    );
  }

  if (c.kind === "email") {
    return v ? <a href={`mailto:${v}`}>{v}</a> : <span>No email provided</span>;
  }

  if (c.kind === "phone") {
    return v ? <a href={`tel:${v}`}>{v}</a> : <span>No phone provided</span>;
  }

  // Plain text (address or anything else)
  return v ? <span>{v}</span> : <span>No {c.kind} provided</span>;
}

// previous
// export default function ContentContacts({ contacts = [] }) {
//   if (!contacts.length) return <div className="segment-contacts empty" />;
//   return (
//     <div className="segment-contacts">
//       {contacts.map((c, idx) => (
//         <div key={idx} className={`icon ${c.kind}`}>
//           {/* <div className={`svg ${c.kind}-link`}> */}
//           <div title={c.kind}>
//             {c.icon === "mail" && <Mail />}
//             {c.icon === "phone" && <Phone />}
//             {c.icon === "email" && <AtSign />}
//             {c.icon === "web" && <Globe />}

//             {/* <img
//                 src={c.icon}
//                 width="24"
//                 height="24"
//                 className="link-icon"
//                 alt={c.kind}
//                 title={c.kind}
//               /> */}

//             {c.value ? <span className="tooltiptext">{c.value}</span> : null}
//           </div>
//           {/* </div> */}
//         </div>
//       ))}
//     </div>
//   );
// }
